import { useState, useEffect, useCallback, useRef } from "react";
import VendorKYC from "./kyc";
import Documents from "./Documents";
import IncomeDocs from "./IncomeDoc";
import BankAccount from "./BankAccount";
import Designation from "./Designation";
import LetterHeads from "./LetterHeads";
import TermCondition from "./TermCondition";
import AccountMember from "./AccountMember";
import ApprovalSetting from "./ApprovalSetting";
import UserAddress from "./UserAddress";
import axiosInstance from "../../api/axiosInstance";

// ── API layer ────────────────────────────────────────────────────────────────
const vendorDetailApi = {
  get: (vendorProfileId) =>
    axiosInstance.get(`/api/superadmin/vendors/${vendorProfileId}/`),
};

const I = {
  back: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="15 18 9 12 15 6" /></svg>,
  user: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
  building: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></svg>,
  phone: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.1a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>,
  mail: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>,
  globe: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>,
  map: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>,
  calendar: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="3" y1="10" x2="21" y2="10" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /></svg>,
  shield: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><polyline points="9 12 11 14 15 10" /></svg>,
  file: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>,
  bank: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>,
  income: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" /></svg>,
  overview: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>,
  tag: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg>,
  link: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></svg>,
  check: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>,
  cross: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>,
  spinner: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ animation: "vdd-spin .8s linear infinite" }}><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" /></svg>,
  download: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>,
  close: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>,
};

const TOAST_MS = 4000;
let _vddSetter = null;
const toast = {
  _push: (item) => { const id = Date.now() + Math.random(); _vddSetter?.((p) => [...p, { id, ...item }]); return id; },
  success: (t, m) => toast._push({ type: "success", title: t, msg: m }),
  error:   (t, m) => toast._push({ type: "error",   title: t, msg: m }),
  info:    (t, m) => toast._push({ type: "info",     title: t, msg: m }),
  loading: (t)    => toast._push({ type: "loading",  title: t, persistent: true }),
  dismiss: (id)   => _vddSetter?.((p) => p.filter((x) => x.id !== id)),
};
const TMETA = { success: { bar: "#16a34a", icon: "✓" }, error: { bar: "#dc2626", icon: "✕" }, info: { bar: "#1d4ed8", icon: "i" }, loading: { bar: "#94a3b8" } };
const TItem = ({ t, onDismiss }) => {
  const m = TMETA[t.type];
  const [prog, setProg] = useState(100);
  const [exit, setExit] = useState(false);
  const raf = useRef(null); const ts = useRef(Date.now());
  const dismiss = useCallback(() => { setExit(true); setTimeout(() => onDismiss(t.id), 280); }, [t.id, onDismiss]);
  useEffect(() => {
    if (t.persistent) return;
    const tick = () => { const p = Math.max(0, 100 - ((Date.now() - ts.current) / TOAST_MS) * 100); setProg(p); if (p > 0) raf.current = requestAnimationFrame(tick); else dismiss(); };
    raf.current = requestAnimationFrame(tick); return () => cancelAnimationFrame(raf.current);
  }, [t.persistent, dismiss]);
  return (
    <div style={{ position: "relative", overflow: "hidden", background: "#fff", borderRadius: 10, borderLeft: `4px solid ${m.bar}`, boxShadow: "0 4px 20px rgba(0,0,0,.1)", minWidth: 280, maxWidth: 340, animation: exit ? "vdd-alOut .28s ease forwards" : "vdd-alIn .28s cubic-bezier(.34,1.56,.64,1) forwards" }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "12px 13px 13px" }}>
        <div style={{ width: 22, height: 22, borderRadius: "50%", background: `${m.bar}18`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          {t.type === "loading" ? <svg width="12" height="12" viewBox="0 0 13 13" fill="none" style={{ animation: "vdd-spin .85s linear infinite" }}><circle cx="6.5" cy="6.5" r="5" stroke={m.bar} strokeWidth="2" strokeDasharray="8 20" strokeLinecap="round" /></svg>
            : <span style={{ fontSize: 11, fontWeight: 800, color: m.bar }}>{m.icon}</span>}
        </div>
        <div style={{ flex: 1 }}><p style={{ margin: 0, fontSize: 13, fontWeight: 650, color: "#0f172a" }}>{t.title}</p>{t.msg && <p style={{ margin: "3px 0 0", fontSize: 12, color: "#64748b" }}>{t.msg}</p>}</div>
        <button onClick={dismiss} style={{ background: "none", border: "none", cursor: "pointer", color: "#cbd5e1", padding: 2, display: "flex" }}>{I.close}</button>
      </div>
      {!t.persistent && <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 3, background: "#f1f5f9" }}><div style={{ height: "100%", width: `${prog}%`, background: m.bar, transition: "width .1s linear" }} /></div>}
    </div>
  );
};
const ToastContainer = () => {
  const [toasts, setToasts] = useState([]); _vddSetter = setToasts;
  const dismiss = useCallback((id) => setToasts((p) => p.filter((t) => t.id !== id)), []);
  if (!toasts.length) return null;
  return <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 9999, display: "flex", flexDirection: "column", gap: 8, alignItems: "flex-end" }}>{toasts.map((t) => <TItem key={t.id} t={t} onDismiss={dismiss} />)}</div>;
};

const Shimmer = ({ w, h = 14 }) => (
  <div style={{ height: h, width: w || "100%", borderRadius: 6, background: "linear-gradient(90deg,#f1f5f9 25%,#e2e8f0 50%,#f1f5f9 75%)", backgroundSize: "200% 100%", animation: "vdd-shimmer 1.4s infinite" }} />
);

const InfoRow = ({ icon, label, value, mono, badge }) => (
  <div style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "9px 0", borderBottom: "1px solid #f8fafc" }}>
    <span style={{ color: "#94a3b8", display: "flex", flexShrink: 0, marginTop: 1 }}>{icon}</span>
    <span style={{ fontSize: 12.5, color: "#94a3b8", fontWeight: 600, minWidth: 160, flexShrink: 0 }}>{label}</span>
    {badge ? badge : (
      <span style={{ fontSize: 13, color: mono ? "#1e40af" : "#1e293b", fontWeight: mono ? 700 : 500, fontFamily: mono ? "monospace" : "inherit", flex: 1, wordBreak: "break-word" }}>
        {value ?? <span style={{ color: "#e2e8f0" }}>—</span>}
      </span>
    )}
  </div>
);

const SectionHead = ({ icon, title, count }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "20px 0 10px", paddingBottom: 6, borderBottom: "1.5px solid #f1f5f9" }}>
    <span style={{ color: "#6366f1", display: "flex" }}>{icon}</span>
    <h4 style={{ margin: 0, fontSize: 13.5, fontWeight: 700, color: "#0f172a" }}>{title}</h4>
    {count != null && <span style={{ fontSize: 11.5, background: "#f1f5f9", color: "#64748b", padding: "1px 7px", borderRadius: 20, fontWeight: 600 }}>{count}</span>}
  </div>
);

const BoolTag = ({ value, trueLabel = "Yes", falseLabel = "No" }) => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 8px", borderRadius: 6, fontSize: 12, fontWeight: 700, background: value ? "#dcfce7" : "#fee2e2", color: value ? "#16a34a" : "#dc2626" }}>
    {value ? I.check : I.cross} {value ? trueLabel : falseLabel}
  </span>
);

const ONBOARDING_CFG = {
  submitted:       { bg: "#dcfce7", color: "#16a34a", dot: "#22c55e" },
  step4_financial: { bg: "#fef3c7", color: "#d97706", dot: "#f59e0b" },
  step3_documents: { bg: "#dbeafe", color: "#1d4ed8", dot: "#3b82f6" },
  step2_pan:       { bg: "#ede9fe", color: "#7c3aed", dot: "#8b5cf6" },
  step1_gst:       { bg: "#e0f2fe", color: "#0369a1", dot: "#38bdf8" },
};
const OnboardingBadge = ({ stage, label }) => {
  const cfg = ONBOARDING_CFG[stage] || { bg: "#f1f5f9", color: "#64748b", dot: "#94a3b8" };
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "4px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600, background: cfg.bg, color: cfg.color }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: cfg.dot }} />
      {label || stage?.replace(/_/g, " ")}
    </span>
  );
};

const KYC_CFG = {
  verified:    { bg: "#dcfce7", color: "#16a34a", dot: "#22c55e", label: "Verified"     },
  pending:     { bg: "#fef3c7", color: "#d97706", dot: "#f59e0b", label: "Pending"      },
  failed:      { bg: "#fee2e2", color: "#dc2626", dot: "#f43f5e", label: "Failed"       },
  not_started: { bg: "#f1f5f9", color: "#64748b", dot: "#94a3b8", label: "Not Started"  },
};
const KycBadge = ({ status }) => {
  const cfg = KYC_CFG[status] || KYC_CFG.not_started;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600, background: cfg.bg, color: cfg.color }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: cfg.dot }} />
      {cfg.label}
    </span>
  );
};

const OverviewTab = ({ vendor, loading }) => {
  if (loading) return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14, padding: "4px 0" }}>
      {[1,2,3,4,5,6,7].map(i => (
        <div key={i} style={{ display: "flex", gap: 12, padding: "10px 0", borderBottom: "1px solid #f8fafc" }}>
          <Shimmer w={16} h={16} /><Shimmer w={140} h={13} /><Shimmer w={220} h={13} />
        </div>
      ))}
    </div>
  );
  if (!vendor) return null;

  return (
    <div style={{ animation: "vdd-fadeUp .18s ease" }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 8, marginBottom: 16 }}>
        {[
          { label: "Documents",      value: vendor.documents_count,             color: "#3b82f6", bg: "#eff6ff" },
          { label: "Sub-categories", value: vendor.selected_subcategories_count, color: "#8b5cf6", bg: "#ede9fe" },
          { label: "Income Docs",    value: vendor.income_documents_count,       color: "#10b981", bg: "#d1fae5" },
          { label: "Reg. Step",      value: vendor.registration_step,            color: "#f59e0b", bg: "#fef3c7" },
        ].map(({ label, value, color, bg }) => (
          <div key={label} style={{ textAlign: "center", padding: "12px 8px", borderRadius: 10, background: bg, border: `1px solid ${color}22` }}>
            <div style={{ fontSize: 24, fontWeight: 800, color, lineHeight: 1 }}>{value ?? 0}</div>
            <div style={{ fontSize: 10.5, color: "#94a3b8", fontWeight: 600, marginTop: 4 }}>{label}</div>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
        {[
          { label: "GST Status", status: vendor.gst_status },
          { label: "PAN Status", status: vendor.pan_status },
        ].map(({ label, status }) => (
          <div key={label} style={{ padding: "8px 14px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, display: "flex", flexDirection: "column", gap: 4 }}>
            <span style={{ fontSize: 11, fontWeight: 600, color: "#94a3b8", textTransform: "uppercase", letterSpacing: ".05em" }}>{label}</span>
            <KycBadge status={status} />
          </div>
        ))}
        <div style={{ padding: "8px 14px", background: vendor.user_is_active ? "#f0fdf4" : "#fff1f2", border: `1px solid ${vendor.user_is_active ? "#bbf7d0" : "#fecdd3"}`, borderRadius: 10 }}>
          <span style={{ fontSize: 11, fontWeight: 600, color: "#94a3b8", display: "block", marginBottom: 3, textTransform: "uppercase", letterSpacing: ".05em" }}>User</span>
          <BoolTag value={vendor.user_is_active} trueLabel="Active" falseLabel="Inactive" />
        </div>
        {vendor.invited_vendor && (
          <div style={{ padding: "8px 14px", background: "#ede9fe", border: "1px solid #ddd6fe", borderRadius: 10 }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: "#7c3aed" }}>🎟 Invited Vendor</span>
          </div>
        )}
      </div>

      <div style={{ background: "#fff", borderRadius: 10, border: "1px solid #e2e8f0", padding: "14px 16px", marginBottom: 14 }}>
        <p style={{ margin: "0 0 10px", fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: ".06em" }}>Business Details</p>
        <InfoRow icon={I.building} label="Business Name"       value={vendor.business_name} />
        <InfoRow icon={I.building} label="Business Type"       value={vendor.business_type?.replace(/-/g, " ")?.replace(/\b\w/g, c => c.toUpperCase())} />
        <InfoRow icon={I.building} label="Organization Type"   value={vendor.organization_type?.replace(/-/g, " ")?.replace(/\b\w/g, c => c.toUpperCase())} />
        <InfoRow icon={I.building} label="Vendor Type"         value={vendor.vendor_type} />
        <InfoRow icon={I.globe}    label="Website"             value={vendor.website ? <a href={vendor.website} target="_blank" rel="noreferrer" style={{ color: "#2563eb", textDecoration: "none" }}>{vendor.website}</a> : null} />
        <InfoRow icon={I.calendar} label="Onboarding Stage"    badge={<OnboardingBadge stage={vendor.onboarding_stage} label={vendor.onboarding_stage_label} />} />
        <InfoRow icon={I.calendar} label="Income Proof Type"   value={vendor.income_proof_type?.toUpperCase()} />
        <InfoRow icon={I.calendar} label="Reg. Step"           value={`Step ${vendor.registration_step}`} />
      </div>

      <div style={{ background: "#fff", borderRadius: 10, border: "1px solid #e2e8f0", padding: "14px 16px", marginBottom: 14 }}>
        <p style={{ margin: "0 0 10px", fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: ".06em" }}>Contact Details</p>
        <InfoRow icon={I.user}  label="Contact Person"   value={vendor.contact_person_name} />
        <InfoRow icon={I.mail}  label="User Email"        value={vendor.user_email} />
        <InfoRow icon={I.mail}  label="Alternate Email"   value={vendor.alternate_email} />
        <InfoRow icon={I.phone} label="Phone"             value={vendor.user_phone} />
        <InfoRow icon={I.phone} label="Alternate Phone"   value={vendor.alternate_phone} />
        <InfoRow icon={I.phone} label="Contact Phone"     value={vendor.contact_phone} />
        {vendor.contact_person_designations?.length > 0 && (
          <InfoRow icon={I.tag} label="Designations"
            value={vendor.contact_person_designations.map(d => d.name).join(", ")} />
        )}
      </div>

      {vendor.location && (
        <div style={{ background: "#fff", borderRadius: 10, border: "1px solid #e2e8f0", padding: "14px 16px", marginBottom: 14 }}>
          <p style={{ margin: "0 0 10px", fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: ".06em" }}>Location</p>
          <InfoRow icon={I.map} label="City"     value={vendor.location.city_name || vendor.city_name} />
          <InfoRow icon={I.map} label="State"    value={vendor.location.state_name} />
          <InfoRow icon={I.map} label="Country"  value={vendor.location.country_name} />
          <InfoRow icon={I.map} label="Pincode"  value={vendor.location.pincode} mono />
          {vendor.address_summary && <InfoRow icon={I.map} label="Address" value={vendor.address_summary} />}
        </div>
      )}

      <div style={{ background: "#fff", borderRadius: 10, border: "1px solid #e2e8f0", padding: "14px 16px", marginBottom: 14 }}>
        <p style={{ margin: "0 0 10px", fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: ".06em" }}>Timeline</p>
        <InfoRow icon={I.calendar} label="Created At"          value={vendor.created_at} />
        <InfoRow icon={I.calendar} label="Updated At"          value={vendor.updated_at} />
        <InfoRow icon={I.calendar} label="Step 1 Completed"    value={vendor.step1_completed_at} />
        <InfoRow icon={I.calendar} label="Reminder Sent At"    value={vendor.profile_completion_reminder_sent_at} />
      </div>

      {vendor.selected_subcategories?.length > 0 && (
        <div style={{ background: "#fff", borderRadius: 10, border: "1px solid #e2e8f0", padding: "14px 16px" }}>
          <SectionHead icon={I.tag} title="Selected Sub-categories" count={vendor.selected_subcategories.length} />
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {vendor.selected_subcategories.map(sc => (
              <div key={sc.id} style={{ padding: "6px 12px", background: "#f0f9ff", border: "1px solid #bae6fd", borderRadius: 8 }}>
                <div style={{ fontSize: 12.5, fontWeight: 700, color: "#0369a1" }}>{sc.name}</div>
                <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>{sc.category_name}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};







const DetailSkeleton = () => (
  <div style={{ padding: 24, display: "flex", flexDirection: "column", gap: 16 }}>
    <Shimmer w="50%" h={22} />
    <Shimmer w="35%" h={14} />
    <div style={{ height: 1, background: "#f1f5f9", margin: "8px 0" }} />
    {[1,2,3,4,5,6,7].map(i => (
      <div key={i} style={{ display: "flex", gap: 12, padding: "8px 0", borderBottom: "1px solid #f8fafc" }}>
        <Shimmer w={16} h={16} /><Shimmer w={140} h={13} /><Shimmer w={`${40 + i * 10}%`} h={13} />
      </div>
    ))}
  </div>
);

const TABS = [
  { key: "overview",        label: "Overview",          icon: I.overview, color: "#6366f1" },
  { key: "kyc",             label: "KYC",               icon: I.shield,   color: "#16a34a" },
  { key: "documents",       label: "Documents",          icon: I.file,     color: "#f59e0b" },
  { key: "income",          label: "Income Docs",        icon: I.income,   color: "#10b981" },
  { key: "bank",            label: "Bank Account",       icon: I.bank,     color: "#3b82f6" },
  { key: "designation",     label: "Designation",        icon: I.tag,      color: "#f680f6" },
  { key: "letterhead",      label: "Letter Head",        icon: I.file,     color: "#62bdad" },
  { key: "terms",           label: "Terms & Conditions", icon: I.file,     color: "#62bdad" },
  { key: "accountMember",   label: "Account Member",     icon: I.user,     color: "#62bdad" },
  { key: "approvalSetting", label: "Approval Settings",  icon: I.user,     color: "#62bdad" },
  { key: "userAddress",     label: "User Address",       icon: I.user,     color: "#62bdad" },
];

const VendorDetail = ({ vendorPreview, onBack }) => {
  const [detail,    setDetail]    = useState(null);
  const [loading,   setLoading]   = useState(true);
  const [activeTab, setActiveTab] = useState("overview");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    vendorDetailApi.get(vendorPreview.id)
      .then(({ data }) => {
        // Support both { data: {...} } and flat object responses
        if (!cancelled) setDetail(data?.data ?? data);
      })
      .catch((err) => {
        const status = err?.response?.status;
        if (!cancelled) {
          if (status === 403) {
            toast.error("Access Denied", "You don't have permission to view this vendor.");
          } else if (status === 404) {
            toast.error("Not Found", "This vendor profile no longer exists.");
          } else if (!err.response) {
            toast.error("Network Error", "Unable to reach the server.");
          } else {
            toast.error("Failed to Load", "Could not fetch vendor details.");
          }
        }
      })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [vendorPreview.id]);

  const vendor = detail ?? vendorPreview;

  return (
    <div style={{ fontFamily: "'Inter',-apple-system,sans-serif", minHeight: "100vh", background: "#f8fafc", animation: "vdd-fadeUp .25s ease" }}>
      <style>{`
        @keyframes vdd-shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
        @keyframes vdd-fadeUp  { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:none} }
        @keyframes vdd-alIn    { from{opacity:0;transform:translateX(20px) scale(.97)} to{opacity:1;transform:none} }
        @keyframes vdd-alOut   { from{opacity:1} to{opacity:0;transform:translateX(24px) scale(.95)} }
        @keyframes vdd-spin    { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
        * { box-sizing:border-box; }
        ::-webkit-scrollbar{width:5px;height:5px}
        ::-webkit-scrollbar-thumb{background:#cbd5e1;border-radius:10px}
      `}</style>

      <ToastContainer />

      <div style={{ background: "linear-gradient(135deg,#ffffff 0%,#f8fafc 60%,#f1f5f9 100%)", padding: "24px 28px 0", borderBottom: "1px solid #e2e8f0" }}>
        <button onClick={onBack}
          style={{ display: "flex", alignItems: "center", gap: 6, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, color: "#64748b", cursor: "pointer", padding: "6px 12px", fontSize: 13, fontWeight: 600, marginBottom: 20, transition: "background .15s" }}
          onMouseEnter={(e) => e.currentTarget.style.background = "#f1f5f9"}
          onMouseLeave={(e) => e.currentTarget.style.background = "#f8fafc"}>
          {I.back} Back to Vendor List
        </button>

        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 16, flexWrap: "wrap", marginBottom: 24 }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8, flexWrap: "wrap" }}>
              <OnboardingBadge stage={vendor.onboarding_stage} label={vendor.onboarding_stage_label} />
              {vendor.user_is_active
                ? <span style={{ fontSize: 11.5, background: "#dcfce7", color: "#16a34a", padding: "3px 9px", borderRadius: 20, fontWeight: 600, border: "1px solid #bbf7d0" }}>● Active</span>
                : <span style={{ fontSize: 11.5, background: "#fee2e2", color: "#dc2626", padding: "3px 9px", borderRadius: 20, fontWeight: 600, border: "1px solid #fecaca" }}>● Inactive</span>}
              {vendor.invited_vendor && <span style={{ fontSize: 11.5, background: "#ede9fe", color: "#7c3aed", padding: "3px 9px", borderRadius: 20, fontWeight: 600, border: "1px solid #ddd6fe" }}>🎟 Invited</span>}
            </div>
            <h1 style={{ margin: "0 0 6px", fontSize: 22, fontWeight: 800, color: "#0f172a", lineHeight: 1.25 }}>{vendor.business_name || "Unnamed Vendor"}</h1>
            <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
              {vendor.contact_person_name && <span style={{ fontSize: 13, color: "#64748b", display: "flex", alignItems: "center", gap: 5 }}>{I.user} {vendor.contact_person_name}</span>}
              {vendor.user_email          && <span style={{ fontSize: 13, color: "#64748b", display: "flex", alignItems: "center", gap: 5 }}>{I.mail} {vendor.user_email}</span>}
              {vendor.user_phone          && <span style={{ fontSize: 13, color: "#64748b", display: "flex", alignItems: "center", gap: 5 }}>{I.phone} {vendor.user_phone}</span>}
              {vendor.city_name           && <span style={{ fontSize: 13, color: "#64748b", display: "flex", alignItems: "center", gap: 5 }}>{I.map} {vendor.city_name}</span>}
            </div>
          </div>

          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {[{ label: "GST", status: vendor.gst_status }, { label: "PAN", status: vendor.pan_status }].map(({ label, status }) => {
              const cfg = KYC_CFG[status] || KYC_CFG.not_started;
              return (
                <div key={label} style={{ textAlign: "center", padding: "8px 14px", background: cfg.bg, border: `1px solid ${cfg.dot}33`, borderRadius: 10 }}>
                  <div style={{ fontSize: 10.5, color: "#94a3b8", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".06em" }}>{label}</div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: cfg.color, marginTop: 2 }}>{cfg.label}</div>
                </div>
              );
            })}
            <div style={{ textAlign: "center", padding: "8px 14px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10 }}>
              <div style={{ fontSize: 10.5, color: "#94a3b8", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".06em" }}>Docs</div>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#1e293b", marginTop: 2 }}>{vendor.documents_count ?? "—"}</div>
            </div>
            <div style={{ textAlign: "center", padding: "8px 14px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10 }}>
              <div style={{ fontSize: 10.5, color: "#94a3b8", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".06em" }}>Categories</div>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#1e293b", marginTop: 2 }}>{vendor.selected_subcategories_count ?? "—"}</div>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", gap: 0, overflowX: "auto", scrollbarWidth: "none", marginBottom: 0 }}>
          {TABS.map(tab => (
            <button key={tab.key} onClick={() => setActiveTab(tab.key)}
              style={{ display: "flex", alignItems: "center", gap: 7, padding: "10px 18px", background: "none", border: "none", cursor: "pointer", fontSize: 13, fontWeight: 600, color: activeTab === tab.key ? "#0f172a" : "#64748b", borderBottom: `2.5px solid ${activeTab === tab.key ? tab.color : "transparent"}`, whiteSpace: "nowrap", transition: "color .15s,border-color .15s", paddingBottom: 12 }}>
              <span style={{ color: activeTab === tab.key ? tab.color : "#94a3b8", display: "flex" }}>{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div style={{ padding: "24px 28px 48px", maxWidth: "100%" }}>
        {activeTab === "overview" && (loading && !detail
          ? <DetailSkeleton />
          : <OverviewTab vendor={detail} loading={loading && !detail} />
        )}
        {activeTab === "kyc"            && <VendorKYC      vendorProfileId={vendorPreview.id} />}
        {activeTab === "documents"      && (loading && !detail ? <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>{[1,2,3].map(i => <div key={i} style={{ height: 90, borderRadius: 10, background: "linear-gradient(90deg,#f1f5f9 25%,#e2e8f0 50%,#f1f5f9 75%)", backgroundSize: "200% 100%", animation: "vdd-shimmer 1.4s infinite" }} />)}</div> : <Documents        vendorProfileId={vendorPreview.id} />)}
        {activeTab === "income"         && (loading && !detail ? <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>{[1,2,3].map(i => <div key={i} style={{ height: 110, borderRadius: 10, background: "linear-gradient(90deg,#f1f5f9 25%,#e2e8f0 50%,#f1f5f9 75%)", backgroundSize: "200% 100%", animation: "vdd-shimmer 1.4s infinite" }} />)}</div> : <IncomeDocs       vendorProfileId={vendorPreview.id} />)}
        {activeTab === "bank"           && (loading && !detail ? <DetailSkeleton /> : <BankAccount      vendorProfileId={vendorPreview.id} />)}
        {activeTab === "designation"    && (loading && !detail ? <DetailSkeleton /> : <Designation      vendorProfileId={vendorPreview.id} />)}
        {activeTab === "letterhead"     && (loading && !detail ? <DetailSkeleton /> : <LetterHeads      vendorProfileId={vendorPreview.id} />)}
        {activeTab === "terms"          && (loading && !detail ? <DetailSkeleton /> : <TermCondition    vendorProfileId={vendorPreview.id} />)}
        {activeTab === "accountMember"  && (loading && !detail ? <DetailSkeleton /> : <AccountMember    vendorProfileId={vendorPreview.id} />)}
        {activeTab === "approvalSetting"&& (loading && !detail ? <DetailSkeleton /> : <ApprovalSetting  vendorProfileId={vendorPreview.id} />)}
        {activeTab === "userAddress"    && (loading && !detail ? <DetailSkeleton /> : <UserAddress      vendorProfileId={vendorPreview.id} />)}
      </div>
    </div>
  );
};

export default VendorDetail;